/**
 * Exact decimal input parser for entered money amounts (lease
 * way-entered-money-20261012-01). Preserves the original client grammar —
 * outer-whitespace-trimmed ASCII whole nonnegative digits with an optional
 * decimal point and one or two fraction digits — and its two user-facing
 * errors, while computing minor units with BigInt so entered cents are
 * carried over exactly instead of through Number*100 rounding. Pure: no
 * locale, currency conversion, tax, calculator default, provider or caller
 * state involvement.
 */
const ENTERED_AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;
const INVALID_AMOUNT_MESSAGE = 'Enter an amount with up to two decimal places.';
const OVERFLOW_MESSAGE = 'Amount is too large.';
const MAX_SAFE_MINOR = BigInt(Number.MAX_SAFE_INTEGER);

export function parseEnteredMinor(value: string): number {
  if (typeof value !== 'string') throw new Error(INVALID_AMOUNT_MESSAGE);
  const text = value.trim();
  if (!ENTERED_AMOUNT_PATTERN.test(text)) throw new Error(INVALID_AMOUNT_MESSAGE);
  const separator = text.indexOf('.');
  const whole = separator === -1 ? text : text.slice(0, separator);
  const fraction = separator === -1 ? '00' : text.slice(separator + 1).padEnd(2, '0');
  const cents = BigInt(whole) * 100n + BigInt(fraction);
  if (cents > MAX_SAFE_MINOR) throw new Error(OVERFLOW_MESSAGE);
  return Number(cents);
}
